import { isDevMode } from '@angular/core';
import { throwError } from 'rxjs';
import { ReportType } from '@app/domain/model/report-type';
import { catchError } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { DateFormatter } from '@app/util/date-formatter';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var PaperReportService = /** @class */ (function () {
    function PaperReportService(http) {
        this.http = http;
    }
    PaperReportService.prototype.addPaperReport = function (report) {
        // Convert the purchase report into JSON representation, ...
        var requestBody = JSON.stringify(Object.assign({}, {
            dealerId: report.dealerId,
            reportType: ReportType[report.reportType],
            month: report.month + 1,
            year: report.year,
            dateReceived: DateFormatter.formatDateBeforeSend(report.dateReceived),
            paperPurchaseReportItems: report.paperPurchaseReportItems
        }));
        // ... and send it to the back-end.
        return this.http
            .post('paper/reports/add', requestBody, { headers: { 'Content-Type': 'application/json' } })
            .pipe(catchError(this.handleError));
    };
    PaperReportService.prototype.validatePaperReport = function (report) {
        // Convert the purchase report into JSON representation, ...
        var requestBody = JSON.stringify(Object.assign({}, {
            dealerId: report.dealerId,
            reportType: ReportType[report.reportType],
            month: report.month + 1,
            year: report.year,
            dateReceived: DateFormatter.formatDateBeforeSend(report.dateReceived),
            paperPurchaseReportItems: report.paperPurchaseReportItems
        }));
        // ... and send it to the back-end.
        return this.http
            .post('paper/reports/validate', requestBody, { headers: { 'Content-Type': 'application/json' } })
            .pipe(catchError(this.handleError));
    };
    PaperReportService.prototype.handleError = function (error) {
        if (isDevMode()) {
            console.error('Add paper report problem: ', error);
        }
        return throwError(error);
    };
    PaperReportService.ngInjectableDef = i0.defineInjectable({ factory: function PaperReportService_Factory() { return new PaperReportService(i0.inject(i1.HttpClient)); }, token: PaperReportService, providedIn: "root" });
    return PaperReportService;
}());
export { PaperReportService };
